module.exports = __webpack_public_path__ + "img/Antlia.e226d915.png";